const contentSelectors = document.querySelectorAll('.content-selector');
var lastX = window.innerWidth;

[].forEach.call(contentSelectors, function(contentSelector) {
  initContentSelector(contentSelector);
});

function initContentSelector(contentSelector) {
  if(!contentSelector) {
    return;
  }

  const items = contentSelector.querySelectorAll('.content-selector__item, .content-selector__hotspot-item');

  var activeSpid = 1;

  [].forEach.call(items, function(item) {
    initItem(contentSelector, item);
  });

  function initItem(contentSelector, item) {
    if(!item) {
      return;
    }

    item.addEventListener('click', handleItemClick);

    function handleItemClick(event) {
      var activeItem = contentSelector.querySelector('.content-selector__item--active');
      var activeContent = contentSelector.querySelector('.content-selector__item-content--active');

      var clickedSpid = item.getAttribute("data-spid");

      if (clickedSpid != activeSpid) {
        activeItem.classList.remove('content-selector__item--active');
        activeContent.classList.remove('content-selector__item-content--active');
        contentSelector.querySelector('.content-selector__item[data-spid="' + clickedSpid + '"]').classList.add('content-selector__item--active');
        contentSelector.querySelector('.content-selector__item-content[data-spid="' + clickedSpid + '"]').classList.add('content-selector__item-content--active');
        activeSpid = clickedSpid;
      }

      if(window.innerWidth <= 1023) {
        var activeItem = contentSelector.querySelector('.content-selector__item[data-spid="' + clickedSpid + '"]');
        var viewer = contentSelector.querySelector('.content-selector__viewer');

        activeItem.parentNode.insertBefore(viewer, activeItem.nextSibling);
      }
    }
  }

  var x = window.innerWidth;

  if(x <= 1023) {
    mobileContentSelector(contentSelectors);
  }
}

window.onresize = function(event) {

  var x = window.innerWidth;

  if(x <= 1023 && lastX > 1023) {
    mobileContentSelector(contentSelectors);
  }

  if(x > 1023 && lastX <= 1023) {
    desktopContentSelector(contentSelectors);
  }

  lastX = window.innerWidth;
};

function mobileContentSelector(contentSelectors) {
  [].forEach.call(contentSelectors, function(contentSelector) {
    const viewer = contentSelector.querySelector('.content-selector__viewer');
    const active = contentSelector.querySelector('.content-selector__item--active');

    active.parentNode.insertBefore(viewer, active.nextSibling);
  });
}

function desktopContentSelector(contentSelectors) {
  [].forEach.call(contentSelectors, function(contentSelector) {
    const viewer = contentSelector.querySelector('.content-selector__viewer');
    const list = contentSelector.querySelector('.content-selector__list');

    list.parentNode.insertBefore(viewer, list.nextSibling);
  });
}



// WEBPACK FOOTER //
// ./assets/js/content-selector.js